import { render } from "./Password.vue?vue&type=template&id=6ceb3add&scoped=true&ts=true"
import script from "./Password.vue?vue&type=script&lang=ts"
export * from "./Password.vue?vue&type=script&lang=ts"

import "./Password.vue?vue&type=style&index=0&id=6ceb3add&scoped=true&lang=css"

import exportComponent from "C:\\Projects\\eFJ\\eFjApp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ceb3add"]])

export default __exports__